import { render, staticRenderFns } from "./VQCharityName.vue?vue&type=template&id=27d2be10&"
import script from "./VQCharityName.vue?vue&type=script&lang=js&"
export * from "./VQCharityName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports